import FeedbackDispatcher 		from '../dispatcher/FeedbackDispatcher';
import FeedbackConstants  		from '../constants/FeedbackConstants';
import EventEmitterObj       	from 'events';
var EventEmitter = EventEmitterObj.EventEmitter;
import merge              		from 'merge';
import assign             		from 'object-assign';
import FeedbackActions    		from '../actions/FeedbackActions';

let _feedback 	= [];

function clone( obj ) {
	
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
}

function storeFeedback( feedback ) {

	_feedback = feedback;
}

function acknowledgeItem( itemKey ) {

	let itemID 	 = _feedback[itemKey].id;

	let feedback = clone( _feedback );
	delete feedback[itemKey];

	_feedback = feedback;

	const xhr 	= new XMLHttpRequest();

  	xhr.open( "PUT", "/api/proxy/api/v1/contractor/feedback/" + itemID, true );

  	xhr.send(); 

  	xhr.onreadystatechange 	=  function() {

		if( xhr.readyState === 4 ) {

			switch( xhr.status ) {

				case 200 :
						

					break;
			}
		}	
	};
}

function loadMyFeedback() {

	const xhr 	= new XMLHttpRequest();

  	xhr.open( "GET", "/api/proxy/api/v1/contractor/feedback", true );
  	xhr.setRequestHeader( "Content-Type", "application/json;charset=UTF-8" );

  	xhr.send(); 

  	xhr.onreadystatechange 	=  function() {

		if( xhr.readyState === 4 ) {

			switch( xhr.status ) {

				case 200 :
						
					FeedbackActions.storeFeedback( JSON.parse( xhr.responseText ) );

					break;
			}
		}	
	};
}

var FeedbackStore = merge(EventEmitter.prototype, {

	getMyFeedback : function() {

		return clone( _feedback );
	},

	emitChange: function() {

		this.emit( 'change' );
	},

	addChangeListener: function( callback )  {

		this.on( 'change' , callback);
	},

	removeChangeListener: function( callback ) {

		this.removeListener( 'change', callback);
	}

});

FeedbackDispatcher.register( function( payload ) {

	var returnRes = true;

	switch( payload.actionType ) {

		case FeedbackConstants.LOAD_MY_FEEDBACK :

			loadMyFeedback();

			break;

		case FeedbackConstants.STORE_FEEDBACK :

			storeFeedback( payload.data );

			break;

		case FeedbackConstants.ACKNOWLEDGE_ITEM :

			acknowledgeItem( payload.data );

			break;

		default:

			return true;

			break;
	}

  	FeedbackStore.emitChange();

  	return returnRes;

});

export default FeedbackStore;


// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/stores/FeedbackStore.js